import React from "react";

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section
        className="h-[90vh] bg-cover bg-center flex flex-col justify-center items-center text-white text-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80')",
        }}
      >
        <div className="bg-black/40 p-10 rounded-xl">
          <h1 className="text-5xl font-bold mb-4">Empowering Businesses. Elevating Careers.</h1>
          <p className="text-lg mb-6">
            Blue Shield Labs — Your trusted partner in IT staffing and consulting.
          </p>
          <a
            href="/contact"
            className="bg-blue-700 hover:bg-blue-800 px-6 py-3 rounded-lg font-semibold shadow-lg transition-all"
          >
            Get in Touch →
          </a>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 px-6 max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-semibold text-blue-700 mb-6">
          About Blue Shield Labs
        </h2>
        <p className="text-gray-700 leading-relaxed text-lg">
          We are a forward-thinking IT employment and talent consulting agency,
          connecting professionals with top organizations across the United
          States. Our mission is to empower both clients and candidates through
          innovative, value-driven recruitment and consulting services.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <div className="bg-white shadow-md p-6 rounded-2xl hover:shadow-xl transition-all">
            <img
              src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=80"
              alt="Staffing Solutions"
              className="rounded-xl mb-4"
            />
            <h3 className="text-xl font-semibold mb-2 text-blue-800">Staffing Solutions</h3>
            <p className="text-gray-600">
              Contract, permanent, and executive search solutions tailored for your business needs.
            </p>
          </div>

          <div className="bg-white shadow-md p-6 rounded-2xl hover:shadow-xl transition-all">
            <img
              src="https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&w=800&q=80"
              alt="Consulting"
              className="rounded-xl mb-4"
            />
            <h3 className="text-xl font-semibold mb-2 text-blue-800">Consulting Expertise</h3>
            <p className="text-gray-600">
              Our experienced consultants guide you to the right talent and strategic decisions.
            </p>
          </div>

          <div className="bg-white shadow-md p-6 rounded-2xl hover:shadow-xl transition-all">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80"
              alt="Career Growth"
              className="rounded-xl mb-4"
            />
            <h3 className="text-xl font-semibold mb-2 text-blue-800">Career Growth</h3>
            <p className="text-gray-600">
              Helping professionals find meaningful work that aligns with their goals and lifestyle.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
